import { useQuery } from '@tanstack/react-query';
import { numberSchemes } from '@/api/numberSchemes';

/**
 * Превʼю майбутнього номера документа.
 * Повертає null якщо isNew=false (для існуючого документа) або немає org_id.
 */
export function useNumberPreview(
  documentType: string,
  organizationId: string | undefined,
  isNew: boolean,
) {
  const q = useQuery({
    queryKey: ['number-preview', documentType, organizationId ?? ''],
    queryFn: () => numberSchemes.preview({
      document_type: documentType,
      organization_id: organizationId,
    }),
    enabled: isNew && !!organizationId,
    staleTime: 60_000, // 1 хвилина — не дергаємо часто
  });
  return q.data?.preview ?? null;
}
